export default "__VITE_ASSET__6GqxrufY__"